<template>
    <el-dialog
            :title="dataForm.id?'编辑':'新增'"
            :visible.sync="visible"
            :append-to-body="true"
            width="700px">
        <el-steps :active="active" align-center space="200px">
            <el-step title="基本信息"></el-step>
            <el-step title="详细内容"></el-step>
        </el-steps>
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="80px">
            <!-- 基本信息 -->
            <template v-if="active===1">
                <el-form-item label="订单号" v-if="dataForm.id" prop="orderNo">
                    <span>{{dataForm.orderNo}}</span>
                </el-form-item>
                <el-form-item label="客户姓名" prop="cusName">
                    <el-input type="text" v-model="dataForm.cusName" style="width: 90%;" clearable></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="cusPhone">
                    <el-input type="text" v-model="dataForm.cusPhone" style="width: 90%;" clearable></el-input>
                </el-form-item>
                <el-form-item label="小区地址" prop="cusAddress">
                    <el-input type="text" v-model="dataForm.cusAddress" style="width: 90%;" clearable></el-input>
                </el-form-item>
                <el-form-item label="订单类型" prop="orderType">
                    <el-radio-group v-model="dataForm.orderType">
                        <el-radio :label="1">装修</el-radio>
                        <el-radio :label="2">兔狗</el-radio>
                        <el-radio :label="3">销售</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="服务人员" prop="userId">
                    <el-select v-model="dataForm.userId" value-key filterable multiple placeholder="请选择" clearable>
                        <el-option
                                v-for="item in userList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            <span style="float: left">
                                {{ item.name }}
                                <span style="color: #8492a6; font-size: 12px;">（{{item.deleteStatus ? '离职' : '在职'}}）</span>
                            </span>
                            <span style="float: right; color: #8492a6; font-size: 12px;margin-right: 30px;">
                            <template v-if="item.deparment===2">采购部</template>
                            <template v-if="item.deparment===3">财务部</template>
                            <template v-if="item.deparment===4">人事部</template>
                            <template v-if="item.deparment===5">网络部</template>
                            <template v-if="item.deparment===6">设计部</template>
                            <template v-if="item.deparment===7">销售部</template>
                        </span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单状态" prop="status">
                    <el-radio-group v-model="dataForm.status">
                        <el-radio :label="1">定金</el-radio>
                        <el-radio :label="2">80%货款</el-radio>
                        <el-radio :label="3">尾款</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="设计图">
                    <el-upload
                            class="upload-demo"
                            action="https://b.365jiaju.net/api/edu/upload/image"
                            name="picture"
                            :multiple="true"
                            :before-upload="beforeUpload"
                            :on-preview="handlePreview"
                            :on-success="handleSuccess"
                            :on-remove="handleRemove"
                            :file-list="designList"
                            list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="报价">
                    <el-upload
                            class="upload-demo"
                            drag
                            action="https://b.365jiaju.net/api/edu/upload/file"
                            :on-success="priceSuccess"
                            :on-remove="priceRemove"
                            :file-list="priceList"
                            multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-form-item>
            </template>
            <!-- 详细内容 -->
            <template v-if="active===2">
                <el-form-item label="订单合同">
                    <el-upload
                            class="upload-demo"
                            drag
                            action="https://b.365jiaju.net/api/edu/upload/file"
                            :on-success="fileSuccess"
                            :on-remove="fileRemove"
                            :file-list="orderFileList"
                            multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="摆场实拍">
                    <el-upload
                            action="https://b.365jiaju.net/api/edu/upload/image"
                            name="picture"
                            :multiple="true"
                            :before-upload="beforeUpload"
                            list-type="picture-card"
                            :on-preview="handlePreview"
                            :on-success="photoSuccess"
                            :on-remove="photoRemove"
                            :file-list="photoList">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                    <span style="color: #ff6779;font-size: 12px;">*只能上传jpg、png格式的图片</span>
                </el-form-item>
                <el-form-item label="配送时间" prop="deliveryDate">
                    <el-date-picker
                            v-model="dataForm.deliveryDate"
                            type="datetime"
                            placeholder="选择日期时间"
                            align="right"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="售后情况" prop="afterSale">
                    <el-input type="text" v-model="dataForm.afterSale" style="width: 90%;" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input type="textarea" v-model="dataForm.remarks" :rows="3" style="width: 90%;"
                              clearable></el-input>
                </el-form-item>
            </template>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="visible = false">取消</el-button>
        <el-button v-if="active===2" @click="prev">上一步</el-button>
        <el-button type="primary" v-if="active<2" @click="next">下一步</el-button>
        <el-button type="primary" v-if="active===2" @click="dataFormSubmit()">保存</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {Order} from "../../api/order";

    export default {
        name: "order-add-or-update",
        data() {
            let validatePhone = (rule, value, callback) => {
                let term = /^1(3|4|5|7|8)\d{9}$/;
                if (!term.test(value)) {
                    callback(new Error('手机号码有误，请重新输入！'))
                } else {
                    callback()
                }
            };
            let validateUserName = (rule, value, callback) => {
                if (this.userId === '') {
                    callback(new Error('请选择服务人员！'))
                } else {
                    callback()
                }
            };
            return {
                visible: false,
                active: 1,
                dialogImageUrl: '',
                dialogVisible: false,
                fileList: [],
                fileList1: [],
                fileList2: [],
                fileList3: [],
                designList: [],
                priceList: [],
                orderFileList: [],
                photoList: [],
                pickerOptions: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                userList: [], //用户列表
                dataForm: {
                    id: 0,
                    orderNo: '',
                    userId: '',
                    cusName: '',
                    cusPhone: '',
                    cusAddress: '',
                    orderType: 1,
                    status: 1,
                    deliveryDate: '',
                    afterSale: '',
                    remarks: ''
                },
                orderFile: '',
                orderPrice: '',
                orderDesign: '',
                photo: '',
                dataRule: {
                    cusName: [
                        {required: true, message: '客户姓名不能为空', trigger: 'blur'}
                    ],
                    cusPhone: [
                        {required: true, message: '联系电话不能为空', trigger: 'blur'},
                        {validator: validatePhone, trigger: 'blur'}
                    ],
                    cusAddress: [
                        {required: true, message: '小区地址不能为空', trigger: 'blur'}
                    ],
                    userId: [
                        {required: true, message: '请选择服务人员！', trigger: 'blur'},
                        {validator: validateUserName, trigger: 'blur'}
                    ],
                    deliveryDate: [
                        {required: true, message: '配送时间不能为空', trigger: 'blur'}
                    ]
                }
            }
        },

        watch: {
            //弹出层关闭清空数据
            visible(newValue, oldValue) {
                if (newValue === false) {
                    this.$nextTick(() => {
                        this.dataForm.id = 0;
                        this.dataForm.orderNo = '';
                        this.dataForm.userId = '';
                        this.dataForm.cusName = '';
                        this.dataForm.cusPhone = '';
                        this.dataForm.cusAddress = '';
                        this.dataForm.orderType = 1;
                        this.dataForm.status = 1;
                        this.dataForm.deliveryDate = '';
                        this.dataForm.afterSale = '';
                        this.dataForm.remarks = '';
                        this.$refs['dataForm'].clearValidate();
                    });
                }
            }
        },

        methods: {
            prev() {
                this.active = this.active - 1;
            },
            next() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.active = this.active + 1;
                    }
                });
            },
            //获取服务人员列表
            getLists() {
                Order.getUserList().then(res => {
                    if (res.code === 0) {
                        let userList = res.userList;
                        userList.splice(0, 1);
                        this.userList = userList;
                    }
                });
            },
            //文件上传前的前的钩子函数
            //参数是上传的文件，若返回false，或返回Primary且被reject，则停止上传
            beforeUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isGIF = file.type === 'image/gif';
                const isPNG = file.type === 'image/png';
                const isBMP = file.type === 'image/bmp';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG && !isGIF && !isPNG && !isBMP) {
                    this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
            },
            //点击列表中已上传的文件事的钩子函数
            handlePreview(file) {
            },
            //文件上传成功的钩子函数
            handleSuccess(res, file) {
                this.$message({
                    type: 'success',
                    message: '图片上传成功',
                    duration: 1500
                });
                this.fileList.push(res.url);
                this.orderDesign = this.fileList.join(',');
            },
            //删除文件之前的钩子函数
            handleRemove(file, fileList) {
                let files = [];
                console.log(fileList);
                fileList.forEach((item, index) => {
                    if (item.response) {
                        files.push(item.response.url);
                    } else {
                        files.push(item.url);
                    }
                });
                this.fileList = files;
                this.orderDesign = files.join(',');
                //console.log(this.dataForm.orderDesign);
                this.$message({
                    type: 'info',
                    message: '已删除原有图片',
                    duration: 1500
                });
            },
            priceSuccess(res, file) {
                this.$message({
                    type: 'success',
                    message: '文件上传成功',
                    duration: 1500
                });
                this.fileList1.push(file.name);
                this.orderPrice = this.fileList1.join(',');
            },
            priceRemove(file, fileList) {
                let files = [];
                fileList.forEach(item => {
                    files.push(item.name);
                });
                this.fileList1 = files;
                this.orderPrice = files.join(',');
                this.$message({
                    type: 'info',
                    message: '已删除原有文件',
                    duration: 1500
                });
            },
            fileSuccess(res, file) {
                this.$message({
                    type: 'success',
                    message: '文件上传成功',
                    duration: 1500
                });
                this.fileList2.push(file.name);
                this.orderFile = this.fileList2.join(',');
            },
            fileRemove(file, fileList) {
                let files = [];
                fileList.forEach(item => {
                    files.push(item.name);
                });
                this.fileList2 = files;
                this.orderFile = files.join(',');
                this.$message({
                    type: 'info',
                    message: '已删除原有文件',
                    duration: 1500
                });
            },
            photoSuccess(res, file) {
                this.$message({
                    type: 'success',
                    message: '图片上传成功',
                    duration: 1500
                });
                this.fileList3.push(res.url);
                this.photo = this.fileList3.join(',');
            },
            photoRemove(file, fileList) {
                let files = [];
                console.log(fileList);
                fileList.forEach((item, index) => {
                    if (item.response) {
                        files.push(item.response.url);
                    } else {
                        files.push(item.url);
                    }
                });
                this.fileList3 = files;
                this.photo = files.join(',');
                //console.log(this.dataForm.orderDesign);
                this.$message({
                    type: 'info',
                    message: '已删除原有图片',
                    duration: 1500
                });
            },
            init(id) {
                this.visible = true;
                this.dataForm.id = id;
                this.active = 1;
                this.userList = [];
                this.designList = [];
                this.fileList = [];
                this.priceList = [];
                this.fileList1 = [];
                this.orderFileList = [];
                this.fileList2 = [];
                this.photoList = [];
                this.fileList3 = [];
                this.getLists();
                if (this.dataForm.id) { // 查询
                    Order.getOrderInfo(this.dataForm.id).then(res => {
                        if (res.code === 0) {
                            this.dataForm.orderNo = res.order.orderNo;
                            this.dataForm.cusName = res.order.cusName;
                            this.dataForm.cusPhone = res.order.cusPhone;
                            this.dataForm.cusAddress = res.order.cusAddress;
                            let userArray = res.order.userId.split(',');
                            userArray.forEach((item, index) => {
                                userArray[index] = Number(item)
                            });
                            this.dataForm.userId = userArray;
                            this.dataForm.orderType = res.order.orderType;
                            this.dataForm.deliveryDate = res.order.deliveryDate;
                            this.dataForm.afterSale = res.order.afterSale;
                            this.dataForm.remarks = res.order.remarks;
                            this.dataForm.status = res.order.status;
                            this.orderFile = res.order.orderFile;
                            this.orderPrice = res.order.orderPrice;
                            this.orderDesign = res.order.orderDesign;
                            this.photo = res.order.photo;
                            if (res.order.orderFile) {
                                this.fileList2 = res.order.orderFile.split(',');
                                res.order.orderFile.split(',').forEach((item, index) => {
                                    this.orderFileList.push({name: item});
                                });
                            }
                            if (res.order.orderPrice) {
                                this.fileList1 = res.order.orderPrice.split(',');
                                res.order.orderPrice.split(',').forEach((item, index) => {
                                    this.priceList.push({name: item});
                                });
                            }
                            if (res.order.orderDesign) {
                                this.fileList = res.order.orderDesign.split(',');
                                res.order.orderDesign.split(',').forEach((item, index) => {
                                    this.designList.push({url: item});
                                });
                            }
                            if (res.order.photo) {
                                this.fileList3 = res.order.photo.split(',');
                                res.order.photo.split(',').forEach((item, index) => {
                                    this.photoList.push({url: item});
                                });
                            }
                        }
                    });
                }
            },
            /**
             * 提交
             */
            dataFormSubmit() {
                let datas = {
                    'id': this.dataForm.id,
                    'cusName': this.dataForm.cusName,
                    'cusPhone': this.dataForm.cusPhone,
                    'cusAddress': this.dataForm.cusAddress,
                    'userId': this.dataForm.userId.join(','),
                    'orderType': this.dataForm.orderType,
                    'tempDate': this.dataForm.deliveryDate,
                    'afterSale': this.dataForm.afterSale,
                    'remarks': this.dataForm.remarks,
                    'status': this.dataForm.status,
                    'orderDesign': this.orderDesign,
                    'orderFile': this.orderFile,
                    'orderPrice': this.orderPrice,
                    'photo': this.photo
                };
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let type = this.dataForm.id ? 'update' : 'save';
                        Order.addOrUpdateOrder(type, datas).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$nextTick(() => {
                                            this.$emit('getDataList');
                                        })
                                    }
                                })
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .el-steps {
        width: 300px;
        margin: 0 auto;
    }

    .el-form {
        width: 600px;
        margin: 50px auto;
    }

    .upload-demo {
        width: 300px;
    }
</style>
